import React, { Component } from 'react'
import { Button, Box, Text, Anchor, TextArea, CheckBox } from 'grommet';
/*import Header from '../Components/Header';
import Footer from '../Components/Footer';*/
import ReactTable from "react-table";
import Pagination from '../Components/Pagination';
import 'react-accessible-accordion/dist/fancy-example.css';
import pdf from '../Assets/document/pdf/modulo_evasione_con_altri_mezzi.pdf'
import data from '../Data.json';

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemButton
} from 'react-accessible-accordion';
import MenuDispute from '../Components/MenuDispute';
import { maskCardNumber } from '../Utils/Utility';

export default class DettaglioPraticaDispute extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: false
        }
        this.setCheckbox = this.setCheckbox.bind(this);
    }
    setCheckbox() {
        this.setState({
            checked: !this.state.checked
        })
    }
    render() {




        const columns = [
            {
                Header: ' Data creazione',
                accessor: 'insegna',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },

            {
                Header: ' Stato',
                accessor: 'insegna',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'Messaggio',
                accessor: 'codes',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'Allegati',
                accessor: 'indirizzo',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },


        ]
        return (

            <Box>

                <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }} >
                    <Box className='contentbox' >
                        <Box>
                            <MenuDispute></MenuDispute>
                        </Box>
                        <Box align='start' style={{ margin: '20px 22px ' }}>
                            <Text className='titlehome'>DISPUTE ONLINE - DETTAGLIO PRATICA</Text>
                        </Box>

                        <Box style={{ padding: '24px 20px' }}>

                            <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Dati pratica
                                                 </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='row' className='accordionText'>
                                            <Box>
                                                <Text>Numero pratica</Text>
                                                <Text>Tipo pratica</Text>
                                                <Text>Data apertura</Text>
                                                <Text>Stato</Text>
                                            </Box>
                                            <Box>
                                                <Text>Numero pratica</Text>
                                                <Text>Tipo pratica</Text>
                                                <Text>Numero pratica</Text>
                                                <Text>Tipo pratica</Text>
                                            </Box>
                                        </Box>
                                    </AccordionItemPanel>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Dati esercente
                                                  </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>

                                        <Box direction='row' className='accordionText'>
                                            <Box>
                                                <Text>Codice societario</Text>
                                                <Text>Codice esercente</Text>
                                                <Text>Insegna / località</Text>
                                            </Box>
                                            <Box>
                                                <Text>9001803766</Text>
                                                <Text>9525525572</Text>
                                                <Text>LA RINASCENTE DUOMO 028852250</Text>
                                                <Text>Tipo pratica</Text>
                                            </Box>

                                        </Box>


                                    </AccordionItemPanel>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Dati operazione
                                                </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='row' className='accordionText'>
                                            <Box>
                                                <Text>Data</Text>
                                                <Text>Ora</Text>
                                                <Text>Numero carta</Text>
                                                <Text>Importo lordo (euro)	</Text>
                                                <Text>Numero autorizzazione	</Text>
                                                <Text>Codice terminale	</Text>
                                                <Text>Numero operazione	</Text>
                                                <Text>ARN</Text>
                                            </Box>
                                            <Box>
                                                <Text>11/08/2017</Text>
                                                <Text>20:50</Text>
                                                <Text>{maskCardNumber('379766389452037')}</Text>
                                                <Text>980,00</Text>
                                                <Text>829907</Text>
                                                <Text>97092814</Text>
                                                <Text>04374</Text>
                                                <Text>71001591722500000050751</Text>


                                            </Box>

                                        </Box>

                                    </AccordionItemPanel>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Documentazione richiesta
                                                </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='column' className='accordionText'>
                                            <Text>
                                                COPIA SCONTRINO FIRMATO
                                                SCONTRINO FISCALE/FATTURA DETTAGLIATA
                                                VOUCHER STAMPIGLIATO
                                                    ULTERIORE DOCUMENTAZIONE IN SUO POSSESSO A GIUSTIFICAZIONE DELL'ADDEBITO</Text>
                                        </Box>

                                    </AccordionItemPanel>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Evadi richiesta via fax/posta
                                                </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='column' className='accordionText'>
                                            <Text>
                                                Se sei momentaneamente impossibilitato ad utilizzare Dispute Online per
                                                la documentazione richiesta, puoi inviarcela via fax al numero 02 34889146
                                                oppure via posta all'indirizzo Dispute Esercenti Amex - Corso Sempione 55
                                                        20145 Milano, allegandola al modulo preimpostato.</Text>
                                            <Box direction='row' id='checkboxDispute' > <CheckBox className='checkbox' checked={this.state.checked} onChange={this.setCheckbox} /> <Anchor style={{ margin: '10px' }} href={pdf} target='blank'>Scarica documento</Anchor></Box>

                                        </Box>
                                    </AccordionItemPanel>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Messaggi
                                                </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='row' className='accordionText' gap='large'>
                                            <Box>
                                                <Text>Inserisci qui eventuali messaggi</Text>
                                                <TextArea></TextArea>
                                            </Box>
                                            <Box>
                                                <Text>Messaggi da American Express</Text>
                                                <TextArea></TextArea>
                                            </Box>
                                        </Box>
                                    </AccordionItemPanel>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Storico pratica
                                                </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='column' className='accordionText' gap='large'>
                                            <ReactTable
                                                PaginationComponent={Pagination}
                                                data={data.table}
                                                columns={columns}
                                                sortable={true}
                                                multiSort={true}
                                                resizable={true}
                                                showPagination={true}
                                                loading={false}
                                                defaultPageSize={data.table.length > 10 ? '10' : data.table.length}
                                                style={{ paddingBottom: '20px' }} />
                                        </Box>
                                    </AccordionItemPanel>
                                </AccordionItem>
                            </Accordion>

                        </Box>
                        <Box alignContent='center'>
                            <Box alignSelf='center'><Button className='btnform' style={{ width: '120px' }}>Indietro</Button></Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    }
}



/*


                        <Accordion multiple={true} >




            <AccordionPanel label='' className='accordionPanel'>

            </AccordionPanel>
            <AccordionPanel label='' className='accordionPanel'>

            </AccordionPanel>
        </Accordion>




        */
